var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCrossSmall = function SvgIconCrossSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_cross_small_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_cross_small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "m10 11.063-3.417 3.416a.681.681 0 0 1-.52.219.758.758 0 0 1-.521-.24.729.729 0 0 1 0-1.062L8.938 10 5.52 6.583a.693.693 0 0 1-.219-.53.769.769 0 0 1 .24-.532.73.73 0 0 1 1.062 0L10 8.937l3.417-3.416a.729.729 0 0 1 1.062 0 .73.73 0 0 1 0 1.062L11.063 10l3.416 3.417c.153.152.23.326.23.52a.718.718 0 0 1-.23.521.73.73 0 0 1-1.062 0L10 11.062Z"
  }))));
};
export default SvgIconCrossSmall;